module.exports = __webpack_public_path__ + "fonts/Noto_Serif_JP-400-515.05ccb15.woff2";